module.exports = __webpack_public_path__ + "dist/media/logo--lt.9a7b6400.svg";